import { render, staticRenderFns } from "./InventoryEdit.vue?vue&type=template&id=482bebc0"
import script from "./InventoryEdit.vue?vue&type=script&lang=js"
export * from "./InventoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports